import { CustomLogConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getCustomLogTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as CustomLogConfig;

	const hasMessageHandlers = (): AdvancedTourStep[] => {
		if (config.messageHandlers.length === 0) return [];
		return [
			{
				id: 'message-handler-options',
				selector: '[data-tour="message-handler-options"]',
				content:
					'Collection of options and rule groups which make up a single message handler. A task may have multiple handlers each with their own set of rules and destinations.',
			},
			{
				id: 'message-handler-destination',
				selector: '[data-tour="message-handler-destination"]',
				content:
					'This is used to select a destination task. Should the rules of the message handler pass, the flow will continue to the set destination.',
			},
			{
				id: 'overwrite-message',
				selector: '[data-tour="overwrite-message"]',
				content:
					'Selecting overwrite message will add the message severity and custom message options. These allow you to set a new message severity and message for the intercepted error. If not selected, the original message severity and message will be used.',
			},
			...(config.messageHandlers[0].overwriteMessage
				? [
						{
							id: 'message-severity',
							selector: '[data-tour="message-severity"]',
							content:
								'This is used to select a new message severity when overwriting an error message, or for creating a new message. Options are Error, Warning, Info and Debug.',
						},
						{
							id: 'custom-message',
							selector: '[data-tour="custom-message"]',
							content:
								'This is used to set a new message on an intercepted message when the overwrite message option is selected. If left empty, the original message will be used with the selected Message Severity.',
						},
					]
				: []),
		];
	};

	return [
		{
			id: 'base-custom-message',
			selector: '[data-tour="base-custom-message"]',
			content:
				'This is the optional default log message that will be written if no message handler is triggered.',
		},
		{
			id: 'base-message-severity',
			selector: '[data-tour="base-message-severity"]',
			content:
				'This is the log severity for the default message. Options are Error, Warning, Info and Debug.',
		},
		{
			id: 'add-message-handler',
			selector: '[data-tour="add-message-handler"]',
			content:
				'Add a message handler to the task, which will contain a number of rule groups and other options to handle errors coming from a previous task or create new logs.',
		},
		...hasMessageHandlers(),
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
